module.exports = __webpack_public_path__ + "img/arrow-down-blue.fc3b77f5.svg";